import utils from '@/mixins/utils.js'
import { getQuantidadeAgendados } from './functions.js'

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @param {Boolean} exibirEspontaneos Indica se o filtro de espontâneos está ativo.
 * @returns {Object}
 */
export function getDataFields(mes = null, exibirEspontaneos = false) {
  const colunaQuantidade = exibirEspontaneos ? 'Espontâneos' : 'Agendados'

  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
      },
    },
    Mãe: 'no_mae',
    [colunaQuantidade]: {
      callback: (item) => {
        return getQuantidadeAgendados(item, mes, exibirEspontaneos)
      },
    },
  }
}

export const infoHtml = ``
